export default function setCurrentUser(currentUserVar) {
    return function (user) {
        currentUserVar(user);
    };
}
